<template>
  <div class="Users">
    <div class="glavni">
      <img src="../assets/img/NAVIGATION.svg" alt>
      <button class="btn btn-info col-1 shadow bg-white-rounded dugme ml-5"><router-link to="/">Home</router-link></button>
      <button class="btn btn-success col-1 shadow bg-white-rounded dugme ml-5"><router-link to="/Messages">Messages</router-link></button>
      <button class="btn col-2 shadow bg-white-rounded dugme btn-danger ml-5 " @click="logOut">Log Out</button>
      <div class="container-fluid d-flex justify-content-end p-0">
        <div class="table-container col-10">
          <h3 class="ml-5 mt-4 font-weight-bold">Upload Users</h3>
          <div class="p-btn-box mr-5 d-flex justify-content-between">
            <p
              class="ml-5"
            >If you would like to seed your mailing with names of people within your organization, add their names here</p>
            <button
              data-toggle="modal"
              data-target="#addUser"
              class="btn col-2 shadow mb-4 bg-white-rounded dugme"
            >Upload User</button>
          </div>

          <div class="modal fade" id="addUser" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <form @submit.prevent="signUp">
                  <div class="row justify-content-center">
                    <div class="col-6 col-width">
                      <input
                        class="form-control my-2 text-center radijus"
                        type="text"
                        id="name"
                        v-model="name"
                        placeholder="Name"
                      >
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6 col-width input">
                      <input
                        class="form-control my-2 text-center radijus"
                        type="email"
                        placeholder="Email"
                        id="email"
                        v-model="email"
                      >
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6 col-width input">
                      <input
                        class="form-control my-2 text-center radijus"
                        type="password"
                        id="password"
                        placeholder="Password"
                        v-model="password"
                      >
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6 col-width input">
                      <input
                        class="form-control my-2 text-center radijus"
                        type="password"
                        placeholder="Confirm pasword"
                        v-model="password_confirmation"
                      >
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <button
                      type="submit"
                      class="col-2 my-4 text-center radijus mint-bcg text-white p-2"
                    >SUBMIT</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="ml-5 col-11 shadow p-3 bg-white rounded">
            <div class="table-box ml-5 mt-4">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">RB</th>
                    <th scope="col">List Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Uploaded Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody id="telo">
                  <tr v-for="(user, index) in users" :key="index">
                    <td scope="col">{{ index+start }}</td>
                    <td scope="col">{{ user.name }}</td>
                    <td scope="col">{{ user.email }}</td>
                    <td scope="col">{{ user.updated_at }}</td>
                    <td>
                      <div class="btn-group dropup">
                        <button
                          type="button"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >...</button>
                        <div class="dropdown-menu">
                          <button class="btn btn-primary" @click="chooseUser(user.id)">
                            <i class="fa fa-pencil"></i>Edit
                          </button>
                          <button class="btn btn-danger del" @click="deleteUser(user.id)">
                            <i class="fa fa-trash"></i>Delete
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
           
               
                <div class="overflow-auto">
                  <b-pagination-nav :link-gen="linkGen" :number-of-pages="lastP" use-router @change="page"></b-pagination-nav>
                </div>
                <!-- <button class="btn border" type="button">&#62;</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalCenterTitle">Edit User</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="editUser($event, currentUser)">
              <div class="row justify-content-center">
                <div class="col-6 col-width">
                  <input
                    class="form-control my-2 text-center radijus"
                    type="text"
                    v-model="name"
                    placeholder="Name"
                  >
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-6 col-width input">
                  <input
                    class="form-control my-2 text-center radijus"
                    type="email"
                    placeholder="Email"
                    v-model="email"
                  >
                </div>
              </div>

              <div class="row justify-content-center">
                <button
                  type="submit"
                  class="col-2 my-4 text-center radijus mint-bcg text-white p-2"
                >SUBMIT</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  
</template>

<script>
import axios from "axios";

export default {
  name: "Users",
  data() {
    return {
      id: "",
      name: "",
      email: "",
      date: "",
      lastP: null,
      users: [],
      password: "",
      password_confirmation: "",
      currentUser: null,
      currentPage: null,
      start: null,
      
    };
  },
  created() {
    axios
      .get(
        "https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/users"
      )
      .then(res => {
        console.log(res);
        this.users = res.data.data.data;
        this.lastP = res.data.data.last_page;
        this.currentPage = res.data.data.current_page;
        this.start = res.data.data.from;
      })
      .catch(error => console.log(error));
  },

  methods: {
    page: function(value) {
      axios
        .get(
          `https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/users?page=${value}`
        )
        .then(res => {
          console.log(res);
          this.users = res.data.data.data;
          this.lastP = res.data.data.last_page;
          this.currentPage = res.data.data.current_page;
          this.start = res.data.data.from;
        })
        .catch(() => this.signupFailed());
    },
     
    editUser(event, userId) {
      const formData = {
        name: this.name,
        email: this.email
      };
      console.log(formData);
      axios
        .put(
          `https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/users/${userId}`,
          formData
        )
        .then(res => {
          console.log(res);
        })
        .catch(error => console.log(error));
        global.$("#exampleModalCenter").modal("hide");
        this.page(this.currentPage);
        this.$swal({
        position: 'center',
        type: 'success',
        title: `Uradili ste sledecu promenu: <br> ${formData.name}  ${formData.email}`,
        showConfirmButton: false,
        timer: 3000
      });
    },

    deleteUser(userId) {
      axios
        .delete(
          `https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/users/${userId}`
        )
        .then(res => {
          console.log(res);
        })
        .catch(error => console.log(error));
        this.page(this.currentPage);
        this.$swal({
        position: 'center',
        type: 'success',
        title: 'User deleted',
        showConfirmButton: false,
        timer: 2000
      });
    },
    signUp() {
      const formData = {
        name: this.name,
        email: this.email,
        password: this.password,
        password_confirmation: this.password_confirmation
      };
      console.log(formData);
      axios
        .post(
          "https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/auth/signup",
          formData
        )
        .then(request => {
          console.log(request);
          global.$("#addUser").modal("hide");
          this.page(this.lastP);
        })
        .catch(error => console.log(error));
    },
    logOut() {
      delete localStorage.token
      delete localStorage.email
      this.$router.replace(this.$route.query.redirect || '/')
    },

    chooseUser(userId) {
      global.$("#exampleModalCenter").modal("show");
      console.log(userId);
      this.currentUser = userId;
      console.log(this.currentUser);
      axios
        .get(
          `https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/users/${userId}`
        )
        .then(res => {
          console.log(res);
          this.name = res.data.data.name;
          this.email = res.data.data.email;
        })
        .catch(error => console.log(error));
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.glavni {
  background-color: #202646;
}
.navbar button {
  border-radius: 0;
  font-size: 0.8rem;
}

button a:active {
  background-color: #202646;
}

.table-container {
  background-color: white;
  height: 100vh;
}

.dugme {
  background: white;
  color: #29e4b7;
  border-radius: 25px;
  height: 40px;
}

.btn-small {
  background-color: rgb(241, 241, 241);
}

.modal {
  height: 100vh;
  top: 20%;
}
</style>
